import React from "react";

const Alert = () => {
  return <div>В разработке...</div>;
};

export default Alert;
